// extracted by mini-css-extract-plugin
export var legendIndicator = "_f6-1";
export var legendRight = "_f6-0";